export default {
  SET_SITE_LOGS: function (state, payload) {
    state.siteLogs = payload;
  }
}
